import { render } from "./caseSlide.vue?vue&type=template&id=b0363e40&scoped=true"
import script from "./caseSlide.vue?vue&type=script&lang=js"
export * from "./caseSlide.vue?vue&type=script&lang=js"

import "./caseSlide.vue?vue&type=style&index=0&id=b0363e40&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0363e40"]])

export default __exports__